import {useMemo, useRef, useState} from 'react';
import {useInstantSearch, useSearchBox, type UseSearchBoxProps} from 'react-instantsearch';
import {useConfigContext} from "@/ConfigProvider";
import {debouncePromise} from "@/utils/debounce";
import {MIN_QUERY_LENGTH, SEARCH_DEBOUNCE_MS} from "@/utils/searchConfig";

export function FundingSearchBox(props: UseSearchBoxProps) {
    const {tc} = useConfigContext();
    const {query, refine} = useSearchBox(props);
    const {status} = useInstantSearch();
    const [inputValue, setInputValue] = useState(query);
    const inputRef = useRef(null);
    const isSearchStalled = status === 'stalled';

    const debouncedRefine = useMemo(
        () => debouncePromise((value: string) => refine(value), SEARCH_DEBOUNCE_MS),
        [refine]
    );

    function setQuery(newQuery: string) {
        setInputValue(newQuery);
        // Only trigger a search once cleared, or once a meaningful query has been typed
        if (newQuery.length > 0 && newQuery.length < MIN_QUERY_LENGTH) return;
        debouncedRefine(newQuery).then();
    }

    return (
        <div className="funding-search-box">
            <form
                action=""
                role="search"
                noValidate
                className="inputGroup searchBar"
            >
                <input
                    ref={inputRef}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    placeholder={tc.fundingSearchPlaceholder}
                    spellCheck={false}
                    maxLength={512}
                    id="fundingSearchBox"
                    type="search"
                    value={inputValue}
                    onChange={(event) => {
                        setQuery(event.currentTarget.value);
                    }}
                />
                <span className="inputGroup__addon">
                    <i className="icon icon-search" aria-hidden={true}></i>
                </span>
                <span hidden={!isSearchStalled} aria-hidden={true}>{tc.search}…</span>
            </form>
        </div>
    );
}
